<template>
    <div class="price-preview" :class="{ 'price-preview--logo' : price.logo }">
        <div class="price-preview__image">
            <lazy-image :src="imageUrl" :src-small="smallPath" :blur="1"></lazy-image>
        </div>
        <h2 class="price-preview__heading heading heading--3" v-html="price.title"></h2>
        <div class="price-preview__text" v-html="price.description">{{ price.description }}<br><a target="blank" style="color:#c6a55a; text-decoration:none;" :href="price.link">{{ price.linktext }}</a></div>
        <div class="price-preview__logo" v-if="price.logo" :class="{ 'price-preview__logo--big': bigLogo }" :style="{ backgroundImage: 'url(' + price.logo + ')' }"></div>
    </div>
</template>
<script>
    import LazyImage from "./LazyImage";
    export default {
        components: {LazyImage},
        props: ["price", "bigLogo"],
        computed: {
            imageUrl() {
                return process.env.BASE_URL + this.price.image;
            },
            smallPath() {
                let smallPath = this.price.image.replace('.jpg', '_small.jpg');
                smallPath = smallPath.replace('.png', '_small.png');

                return process.env.BASE_URL + smallPath;
            }
        }
    }
</script>

<style lang="scss">
    .price-preview {
        &--logo {
            @media (max-width: 1439px) {
                padding-bottom: 75px;
            }
        }

        &__image {
            .lazy-image__placeholder {
                width: 100%;
                padding-bottom: 66%;
                background-size: cover;
                margin-bottom: 30px;
                overflow: hidden;
            }
        }

        &__heading {
            &.heading {
                margin-bottom: 15px;
            }
        }

        &__text {
            font-weight: 400;
            font-family: LegacyPro,Times New Roman,Times,serif;
            font-size: 16px;
            line-height: 1.57;
            color: rgba(96,75,51,.7);
            margin: 0;
        }

        &__logo {
            width: 75px;
            height: 75px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center bottom;
            position: absolute;
            bottom: 20px;
            right: 20px;
            margin-top: 20px;

          &--big {
            width: 125px;
            height: 125px;
            position: relative;
            float: right;
            right: 0;
            margin-top: 0;
          }
        }
    }
</style>


